<template>
  <button
    :class="['item_day',
      {
        active : isSelect || isSelectRange.start || isSelectRange.end,
        activeStart: isSelectRange.start,
        activeInRange: isSelectRange.inRange,
        activeEnd: isSelectRange.end,
        disabled : dayItemData.isPrevMonthDay || dayItemData.isNextMonthDay || dayItemData.isDisabled,
        weekend : dayItemData.isWeekend
      }]"
    :id="`calendar_item${index}`"
    :ref="`itemDay${index}`"
    :style="cssProps"
    :disabled="dayItemData.isDisabled"
    @mouseenter="$emit('onFocuseDate')"
    @mouseover="$emit('onFocuseDate')"
    @click="$emit('onClickDay')">
    <strong
      :class="['date_calendar', { today : dayItemData.isToday }]">{{ Number(dayItemData.date) }}</strong>
  </button>
</template>

<script>
import IconSvg from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/IconSvg';
import { getDocumentElementPositon } from '@lemontree-ai/lemontree-admin-common-front/utils/elementUtils';
import { chartColorData } from '@/adminPackage/constants/chartColorData'
import { mapGetters } from 'vuex';
import { convertDateFormat, dateDiff } from '@lemontree-ai/lemontree-admin-common-front/utils/dateUtils';

export default {
  name: 'DatePickerCalendarDayItem',
  props:{
    index: Number,
    value: [String, Array],
    isRange: Boolean,
    // isSelect: Boolean,
    // isSelectStart: Boolean,
    // isSelectInRange: Boolean,
    // isSelectEnd: Boolean,
    dayItemData: Object,
    focuseDate: String,
  },
  components:{
    IconSvg,
  },
  data(){
    return {
      elementWidth: null,
      isTooltipLeft: false,
    }
  },
  watch:{
    getWindowWidth(){
      this.getElementWidth();
    },
    getWindowHeight(){
      this.getElementWidth();
    },
    getScrollTop(){
      this.getElementWidth();
    },
  },
  computed:{
    ...mapGetters('commonViewport', [ 'getWindowWidth', 'getWindowHeight', 'getScrollTop' ]),
    chartColorData(){
      return chartColorData;
    },
    isHasTooltip(){
      return this.dayItemData.event && this.dayItemData.event.eventDetail
    },
    itemDatElement(){
      // this.itemDatElement = document.getElementById(`calendar_item${this.index}`);
      return this.$refs[`itemDay${this.index}`];
    },
    cssProps(){
      var cssObj = {};
      cssObj = {
        '--minHeight': this.elementWidth ? this.elementWidth-13+'px': 'auto',
      }
      return cssObj
    },
    isThisMonthData(){
      const { isPrevMonthDay, isNextMonthDay } = this.dayItemData;
      return !isPrevMonthDay && !isNextMonthDay;
    },
    isSelect(){
      if(!this.isRange){
        return this.value === this.dayItemData.fullDate;
      }else{
        return false;
      }
    },
    isSelectRange(){
      const day = this.dayItemData.fullDate;
      let result = { start:false, inRange:false, end:false, startOnly: false, endOnly: false }
      if(!this.isRange || this.value.length === 0) return result;
      let startDate = this.value[0];
      let endDate = this.value[1];
      if(startDate && !endDate){
        const startDateBefore = startDate;
        const isChangeStartDate = dateDiff(startDate,this.focuseDate) >= 0;
        if(isChangeStartDate){
          startDate = this.focuseDate;
          endDate = startDateBefore;
        }else{
          endDate = this.focuseDate;
        }
      }
      result.start = startDate === day;
      result.inRange = day > startDate && day < endDate;
      result.end = startDate ? ( endDate ? endDate === day : startDate === day ) : false; 
      return result;
    }
  },
  mounted(){
    this.getElementWidth();
  },
  methods:{
    getElementWidth(){
      if( !this.itemDatElement ) return null;
      this.elementWidth = this.itemDatElement.offsetWidth;
    },
    getTooltipLeft(){
      if( !this.itemDatElement || !this.isHasTooltip ) return false;
      const elementOffset = getDocumentElementPositon(this.itemDatElement);
      const tooltipRight = elementOffset.left + this.elementWidth + 245;
      this.isTooltipLeft = this.getWindowWidth <= tooltipRight;
    },
    onClickEvent(){
      this.getTooltipLeft();
      this.$emit('onClickEvent',`calendar_item${this.index}`)
    },
  }
}
</script>

<style lang="scss" scoped>
.item_day{display:inline-block;position:relative;z-index:1;flex:1 1 14.2%;width:14.2%;height:40px;padding:4px 5px;margin:2px 0;vertical-align:top;box-sizing:border-box;text-align:right}

.item_day .date_calendar{display:block;height:32px;padding:7px 0;border-radius:28px;font-weight:500;font-size:14px;line-height:18px;color:#222;text-align:center;box-sizing:border-box}
.item_day .date_calendar.today{font-weight:500;color:$PRIMARY_COLOR}
.item_day:hover .date_calendar{color:$PRIMARY_COLOR}
.item_day.active .date_calendar{font-weight:500;background-color:$PRIMARY_COLOR;color:#fff}
.item_day.active:hover .date_calendar{color:#fff}

.item_day.disabled{opacity:0.4}
.item_day.disabled:disabled{background-color:rgba($DISABLED_BG,0.3);}
.item_day:disabled:hover{cursor:no-drop}
.item_day:disabled:hover .date_calendar{color:#fff}
.item_day.active:disabled:hover .date_calendar{color:#fff}

.item_day.activeStart{background-color:rgba($PRIMARY_COLOR,.2);border-radius:20px 0 0 20px}
.item_day.activeEnd{background-color:rgba($PRIMARY_COLOR,.2);border-radius:0 20px 20px 0}
.item_day.activeStart.activeEnd{border-radius:20px}
.item_day.activeStart,
.item_day.activeInRange,
.item_day.activeEnd{background-color:rgba($PRIMARY_COLOR,.2);opacity:1;}
/* .item_day:hover ~ .item_day,
.item_day.activeEnd ~ .item_day{background:none} */


@media (prefers-color-scheme: dark) {
  /* .item_day{border-color:#777}
  .item_day.disabled{border-color:#444}
  .item_day .txt_event, */
  .item_day .date_calendar{color:#fff}
  /* .item_day.event{background-color:#3DBF6930} */

  /* .desc_schedule{color:#fff} */
}
</style>